var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 15,
    height: 15,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M8.705,10.714l1.607-1.473a.492.492,0,0,1,.4-.134l.268.134,3.75,1.741c.268.134.268.268.268.536a3.4,3.4,0,0,1-1.071,2.411A3.837,3.837,0,0,1,11.116,15a8.16,8.16,0,0,1-3.75-.937,17.557,17.557,0,0,1-3.75-2.679A22.812,22.812,0,0,1,1.607,8.438,18.512,18.512,0,0,1,.268,5.491,8.242,8.242,0,0,1,0,2.946,3.519,3.519,0,0,1,.938.938,4.073,4.073,0,0,1,3.482,0a.7.7,0,0,1,.536.268l2.009,3.75a.468.468,0,0,0,.134.268.492.492,0,0,1-.134.4L4.286,6.295a.6.6,0,0,0,0,.67A12.789,12.789,0,0,0,5.893,9.107a13.523,13.523,0,0,0,2.143,1.741C8.3,10.982,8.571,10.982,8.705,10.714Z",
    transform: "translate(0 0)",
    fill: "#003d5b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/iconPhone.6697307f255d405299740f6987a58e84.svg";
export { ForwardRef as ReactComponent };